const typeList = [
  { text: "支出", value: "-" },
  { text: "收入", value: "+" }
];

export default typeList